import component from './payment-progress.component';

export default angular
  .module('fizyweb.paycell.paymentprogress', [])
  .component('fizyPaycellPaymentProgress', component).name;



// WEBPACK FOOTER //
// src/app/components/payment-progress/payment-progress.module.ts